// extracted by mini-css-extract-plugin
export default {"calculator":"App_calculator__s9OdN"};